import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '../../components/info/info.component';
import { infoOption } from '../../services/ref';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'investissement-support-form',
    templateUrl: './investissement-support-form.component.html',
    styleUrls: ['./investissement-support-form.component.scss'],
    standalone: false
})
export class InvestissementSupportFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = infoOption;
  error: ValidationErrors = null;

  avDistribution: string;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.avDistribution =
      this.subscriptionFacade.getPledge()?.products[0]?.parameters?.avDistribution;

    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    //avOptionInvestissementProgressifRepartition
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract()?.forEach(({ parameters }) => {
      if (
        !parameters.avOptionInvestissementProgressifRepartition ||
        !parameters.avOptionInvestissementProgressifRepartition.length
      ) {
        this.avOptionInvestissementProgressifRepartition.setErrors({
          incorrect: true,
          message: 'Veuillez renseigner au moins un support',
        });
      }
    });
    this.error = this.avOptionInvestissementProgressifRepartition.errors;

    if (this.form.valid) {
      this.subscriptionFacade.submitPledge(this);
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
